<template>
<div   class="container-fluid">

  <div class="card border-primary">

  <div class="card-header bg-primary text-white">
    <h4> <i class="fas fa-truck-loading mr-3" aria-hidden="true"></i>MOVIMENTI FORNITORE</h4>
  </div>  

  <div class="card-body">

  <div class="row">  
    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-2">

      <div class="card border-info" >
      <div class="card-header bg-info">
        <i style="color:yellow" class="fas fa-stream mr-2" aria-hidden="true"></i>
        <strong>PARAMETRI DI RICERCA</strong></div>
      <div class="card-body text-black">
        
        <supplier-select v-bind:props="supplier" @update="setSupplierId"></supplier-select>
        

        <label class="mt-1" for="date_doc"><strong>da data documento </strong></label>
        <input :disabled="items.length>0" required v-model="params.data1" type="date" class="form-control" placeholder="" >        
    
        <label for="date_doc"><strong>a data documento </strong></label>
        <input :disabled="items.length>0" required v-model="params.data2" type="date" class="form-control" placeholder="" >      
         <label class="mt-1" for="Tipo"><strong>Tipo Movimento </strong></label>
        <select class="form-control  mt-2" v-model="params.typeId">
          <option value="0">TUTTI</option>
          <option value="1">ACQUISTO</option>
          <option value="3">RESO</option>
        </select> 

        <button :disabled="!params.data1" @click="getData()" class="btn btn-primary mt-3 float-right">      
            <i class="fas fa-binoculars mr-2" aria-hidden="true"></i>
            CERCA
            <span v-if="spinner" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>     
        </button>


      </div>
      
      </div>

    </div>
       
  <div class="col">
  <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
  <div v-if="type=='A'">
        
    <supplier-document v-if="componentA>0" @PackingList="print_packingList" @print_pdf="print_PackingSlip" @update="setData" @editVat="setVat" @edit="openDiscount" @open="openDocument" v-bind:props="params"  :key="componentA"/>

  </div>

  <div v-else-if="type=='B'">

    <button @click="type='A'"  class="btn btn-success mt-2 mb-2">LISTA MOVIMENTI</button>
    <bar-document v-bind:item="document"/>
   
    <movement-products v-bind:movementId="movementId" v-bind:storeId="storeId" v-bind:movementType="movementType"   :key="componentB"/>
     
  </div>

  <div v-else-if="type=='C'">

    <div class="card">
      <div class="card-header text-white bg-success">
        <h4>
        MODIFICA SCONTI DOCUMENTO   - {{document.title}} {{document.number}} {{document.data}}  
        </h4>
      </div>
      <div class="card-body">

        <discount-list v-bind:vfocus="true" @update="setDiscountList"></discount-list>
        <button @click="getData()" type="button" class="btn btn-secondary mt-3 mr-5">ANNULLA</button>
        <button @click="updateDocumentDiscount()" type="button" class="btn btn-primary mt-3 ml-5">
          <i class="fas fa-check mr-2" aria-hidden="true"></i>
          MODIFICA</button>
        </div>
    </div>
  </div>
  <div v-else-if="type=='D'">
    <packing-slip  v-bind:documentId="documentId" v-bind:movementId="movementId" ></packing-slip>
    <button @click="getData()" type="button" class="btn btn-secondary mt-3 mr-5">ANNULLA</button>
  </div> 
  <div v-else-if="type=='E'">
   
    <div class="card">
      <div class="card-header text-white bg-success">
        <h4>
        MODIFICA IVA DOCUMENTO   - {{document.title}} {{document.number}} {{document.data}}  
        </h4>
      </div>
      <div class="card-body">
        <updateMovementVat v-bind:vat="0" @update="setUpdatedVat" @close="getData()"></updateMovementVat>
        
        </div>
    </div>

  </div> 
   

 
  </div>

  </div>

  </div>
  </div>

</div>
</template>

<script>
import { mapGetters } from 'vuex';

import supplierSelect            from '@/components/common/SupplierSelect_1.vue'
import supplierDocument          from '@/components/supplier/SupplierMovements.vue'
import movementProducts          from '@/components/shipping/MovementProducts.vue'
import barDocument               from '@/components/common/BarDocument.vue'
import updateMovementProduct     from '@/components/backOffice/UpdateMovementProduct.vue'
import alertBox                  from '@/components/common/AlertBox.vue'
//import jsPDF                     from 'jspdf'
import api                       from '@/api'
import discountList              from '@/components/backOffice/ready/DiscountList.vue'
import PackingSlip               from '@/components/shipping/PackingSlip.vue'
import updateMovementVat         from '@/components/backOffice/UpdateMovementVat.vue'
import printPackingList          from '@/components/mixins/PackingList.js'



  export default {
    mixins :[printPackingList],
    components: { supplierSelect, supplierDocument, movementProducts, barDocument, updateMovementProduct, alertBox, discountList, PackingSlip, updateMovementVat } ,
    data () {
      return {
        

        supplier        : 
        {
          Id            : 0,
          isActive      : true,
        
          optionBase    : true,
          required      : true

        },
        params       :{
        
        supplierId   : 0, 
        typeId       : 0,
        data2        :  new Date().toISOString().slice(0,10),
        
        },
        

        componentA   : 0,
        componentB   : 100,
        storeId      : 0,
        productId    : 0,
        movementId   : 0,
        documentId   : 0,
        type         : 'A',
        document     : {},
        movementType : '',
        items        : [],
        products     : [],
        spinner      : false,
        msg          : {
              title : ''
        },

        /*data1        : '',
        data2        : '',
        */
        
        discount     : {'discount1':0,'discount2':0,'discount3':0},
      
        
      }
    },
    watch :
    {

    },
    
  
    computed: {
     
     ...mapGetters(['company','store']),
            
    },

    methods: 
    {
    updateDocumentDiscount()
    {
      this.UpdateMovementProductsDiscount()
    },
    setVat(item)
    {
        this.document.store    = item.store
        this.document.supplier = item.supplier
        this.document.title    = item.description
        this.document.data     = item.date
        this.document.number   = item.number
        this.document.owner    = item.supplier
        this.movementId        = item.stockMovementId
        this.type = 'E'

    },
    setUpdatedVat(vat)
    {
    
      this.updateMovementVat(vat)
      


    },  
    openDiscount(item)
    {

        this.document.store    = item.store
        this.document.supplier = item.supplier
        this.document.title    = item.description
        this.document.data     = item.date
        this.document.number   = item.number
        this.document.owner    = item.supplier

        this.movementId        = item.stockMovementId

        this.type = 'C'

    },

    setDiscountList(d1,d2,d3)
    {
      
      this.discount.discount1 = d1
      this.discount.discount2 = d2
      this.discount.discount3 = d3

      

    },

   async UpdateMovementProductsDiscount()
      {
        
        this.spinner = true                
        var data  = {'movementId' : this.movementId,'discount1':this.discount.discount1,'discount2':this.discount.discount2,'discount3':this.discount.discount3,}
        
        var sp    = {'sp' : 'spUpdateMovementProductsDiscount'}
        var json  = Object.assign(data, sp);
                
        await api.post(json).then(res => {
          
          if(res.status==200)
            { 
               
              this.msg.title = 'MODIFICA EFFETTUATA.'
              this.msg.body = ''
              this.msg.type = 0
             
            }
           else if(res.status==500)
           {
               
              this.msg.title = 'ATTENZIONE'
              this.msg.body = res.data
              this.msg.type = 1

                
                    
           } 
           else
            {
                

              this.msg.title = 'ATTENZIONE'
              this.msg.body = 'Network Error.'
              this.msg.type = 1

                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          this.spinner = false
        });

  
      },
  
      async updateMovementVat(vat)
      {
        
        this.spinner = true                
        const data  = {'movementId' : this.movementId,'vat':vat}
        
        const sp    = {'sp' : 'spUpdateMovementVat'}
        const json  = Object.assign(data, sp);
                
        await api.post(json).then(res => {
          
          if(res.status==200)
            { 
               
              this.msg.title = 'MODIFICA EFFETTUATA.'
              this.msg.body = ''
              this.msg.type = 0
             
            }
           else if(res.status==500)
           {
               
              this.msg.title = 'ATTENZIONE'
              this.msg.body = res.data
              this.msg.type = 1

                
                    
           } 
           else
            {
                

              this.msg.title = 'ATTENZIONE'
              this.msg.body = 'Network Error.'
              this.msg.type = 1

                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          this.spinner = false
        });

  
      },
  
   
   async print_PackingSlip(item)
      {
        
        
        this.documentId = item.documentId
        this.movementId = item.stockMovementId

        if(item.typeId != 2)
        {
          return
        }
        
        this.type = 'D'
        
      },
      
      async getPackListData()
      {
        
        this.spinner = true                
        var data  = {'movementId' : this.movementId,'companyId' : this.company.Id}
        
        var sp    = {'sp' : 'spPackingList'}
        var json  = Object.assign(data, sp);

        await api.post(json).then(res => {
          
          if(res.status==200)
            { 
              
              console.log(res.data.recordsets)
              let headings = res.data.recordsets[2]
              this.printPackingList(res.data.recordsets,headings)

              
            }
           else if(res.status==500)
           {
                console.log(res.data)

                
                    
           } 
           else
            {
                console.log('Network Error.')                  
                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          this.spinner = false
        });

  
      },

  

      async print_packingList(item)
      {
        
        console.log(item)        
        this.documentId = item.documentId
        this.movementId = item.stockMovementId

        if(item.typeId != 2)
        {
          return
        }
        this.getPackListData()
        //this.type = 'D'
        
      },
      
      


    setData(data)
      {
        this.spinner = false
        if(data==0)
        {
          this.msg.title = 'ATTENZIONE '
          this.msg.body = 'DATI INESISTENTI.'
          this.msg.type = 1
        }
      },
      getData()
      {
        
        this.type = 'A'
        this.params.companyId = this.company.Id
        this.params.mltp = 1
        this.params.type = '1'
        if(this.params.typeId == 0 )
        {
          this.params.type = '1,3' 
          this.params.mltp = -1  
        }
        else if(this.params.typeId == 3)
        {
          this.params.type = '3' 
          
        }
        
        this.msg.title = ''
        this.spinner = true
        
        this.componentA++
        
      },
      setSupplierId(Id)
      { 
        this.params.supplierId = Id

        //this.supplierId = Id
      },
      openDocument(item)
      {
        
        this.document.store    = item.store
        this.document.supplier = item.supplier
        this.document.title    = item.description
        this.document.data     = item.date
        this.document.number   = item.number
        this.document.owner    = item.supplier

        this.movementId        = item.stockMovementId
        this.storeId           = item.storeId
        this.movementType      = item.movementType
        this.componentB++
        this.type = 'B'
        
        
      },

      
      

    }
  }
</script>

<style scoped>
  
h4,p {
  
  
  font-size    : 20px;

}

</style>
